module.exports = __webpack_public_path__ + "static/media/GROW YOUR BUSINESS SEAMLESSI.3546d72c.png";